module.exports = __webpack_public_path__ + "static/media/international-acceptance.bc38b99b.png";